import React from "react";
import ReactSelect from "react-select";
import "./Select.css";

const Select = ({
  options,
  value,
  onChange,
  loading = false,
  placeholder,
  isSearchable = true,
  maxMenuHeight = 200,
  isDisabled = false,
  isClearable = true,
  classNamePrefix = "react-select",
  className = "",
  debug = false,
  ...restProps
}) => {
  return (
    <div className="CustomSelect" style={{ position: 'relative' }}>
      <ReactSelect
        options={options}
        value={value}
        onChange={onChange}
        isDisabled={loading || isDisabled}
        isClearable={isClearable}
        className={`react-select-container ${className}`}
        classNamePrefix={classNamePrefix}
        placeholder={placeholder}
        isSearchable={isSearchable}
        maxMenuHeight={maxMenuHeight}
        menuIsOpen={debug ? true : undefined}
        {...restProps}
      />
    </div>
  );
};

export default Select;
